<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      .page-top-image
        .image
          img(src="../assets/image08.jpg")
        .text
          h1.title Concept
            span.title-caption シャンプーセレクションのコンセプト
  parallax-inview
    animation-fade-in-up
      .page-description
        p 当店の５つのこだわりをご紹介いたします。

  parallax-inview
    animation-fade-in-up
      section.section.is-shampoo
        h2.title 1. 選べるシャンプー<br>
          span.caption Select Shampoo
        p.text “美しい髪はシャンプーから”<br>髪質改善はサロンだけでは限界があります。髪質改善のカギを握るのは、毎日ご自宅などで行う「ホームケア」、その中で最も重要なのが「シャンプー」です。本当に自分にあったシャンプーがわからない・・・そういった声にお答えし、お客様一人一人の髪質、頭皮の状態、なりたいイメージに合わせて厳選した数十種類のシャンプーをご用意致しました。あなたに一番合ったシャンプーをお選びいただくことができます。
        .image
          img(src="../assets/concept_image_02.jpg")

  parallax-inview
    animation-fade-in-up
      section.section.is-improvement
        h2.title 2. 髪質改善<br>
          span.caption Hair Quality Improvement
        p.text 当店では様々な髪質改善の方法をご用意しております。<br>髪の毛のお悩みやダメージの状態に応じて、様々な髪質改善を選ぶことができます。<br><br>例えば、酸熱トリートメントは、髪を酸性化してから熱で定着させることで、髪の毛をしっかりとまとめる効果があります。また、サイエンスアクアは、保湿力に優れた成分が含まれているため、パサつきがちな髪におすすめです。ミネコラは、髪に必要な栄養素を補うことで、髪を健やかに保ちます。サブリミックは、髪のダメージを補修しながら、美しい艶を与えてくれます。<br><br>丁寧なカウンセリングによりお客様の髪質や希望するスタイルに合わせて、最適な髪質改善方法をご提案します。自分に合ったトリートメントを選ばなければ、髪質改善の効果を十分に得ることはできません。つまり、自分にあった髪質改善をしなければ、美しい髪にはなれないということです。<br><br>お客様のお悩みに合わせた髪質改善を提供し、美しい髪を手に入れるお手伝いをさせていただきます。
        .image
          img(src="../assets/concept_image_01.jpg")

  parallax-inview
    animation-fade-in-up
      section.section.is-damageless
        h2.title ３. ダメージレスへのこだわり<br>
          span.caption Commitment To Damageless
        p.text 施術によるダメージも最低限におさえるため、当店では徹底的に選び抜いた薬液を使用しております。カラー、パーマは傷むもの・・・そんな常識を覆し積み上げてきた経験と知識で”なりたい”を叶えます。<br>低アルカリカラー<br>トリートメントパーマ<br>ダメージレスによるカラーパーマの持ち、艶、手触りをご体感ください。
        .image
          img(src="../assets/concept_image_03.jpg")

  parallax-inview
    animation-fade-in-up
      section.section.is-onetoone
        h2.title ４. マンツーマン施術<br>
          span.caption One-on-one Treatment
        p.text 当店では居心地のよい時間を過ごしていただくために、マンツーマンでの施術をさせていただいております。安心してくつろいでいただけるように工夫してお待ちしております。
        .image
          img(src="../assets/concept_image_04.jpg")

  parallax-inview
    animation-fade-in-up
      section.section.is-technical
        h2.title ５. 技術保証<br>
          span.caption Technical Warranty
        p.text 帰宅後、気になることがありましたら無料診断、施術をさせていただいております。<br>・パーマがかかりすぎた、取れてしまった<br>・カラーの色がすぐ落ちしてしまった<br>・家でのお手入れが難しい<br>・・・等、お気軽にご連絡ください。ご満足いただけるまでが当店の技術です。
</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Concept',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  text-align: left;
  margin: 0 25px 80px;
  > .title {
    line-height: 30px;
    margin-bottom: 20px;
    > .caption {
      font-size: 18px;
    }
  }
  > .text {
    margin-bottom: 16px;
  }
  > .image {
    overflow: hidden;
    position: relative;
    > img {
      position: absolute;
    }
  }
  &.is-improvement {
    > .image {
      height: 242px
    }
  }
  &.is-shampoo {
    > .image {
      height: 264px;
      > img {
        top: -68px;
      }
    }
  }
  &.is-damageless {
    > .image {
      height: 264px;
      > img {
        top: -190px;
      }
    }
  }
  &.is-onetoone {
    > .image {
      height: 242px;
    }
  }
  &.is-technical {
    > .image {
      height: 210px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Concept.vue